<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qqY1MU/tc-custom/cover.jpg?1684229397417?1706325224976" alt="This image is the cover for the book Trading Natural Gas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Trading Natural Gas
      </h1>
      <p class="bookDescription body article font2">
        <p>This ""how to"" book covers the various mechanics of natural gas trading, including the physical (cash) market for natural gas production, transportation, distribution, and consumption. It has been 23 years since Trading Natural Gas: A Nontechnical Guide was released, and many things have changed: electronic trading, power market deregulation, fracking and the shale revolution, pipelines reversing flow patterns, and LNG exports from the United States. In this second edition, the author addresses these changes, beginning with a deeper dive into the natural gas market fundamentals of supply, demand, storage, and transportation, maintaining a focus on the relationship to market pricing. Following discussion of the mechanics of trading physical natural gas, the heart of the text remains a study of financial derivative products specific to natural gas trading, presented through definitions and trading examples. Many of these products and concepts are still current and have been refreshed and kept intact. New material on the role of natural gas in the power market as it relates to fuel- switching and economic dispatch, as well as a survey of the global LNG market and US exports, is included in this second edition to bring in two of the biggest factors influencing prices in today’s market. Additional statistics, tables, graphs and suggested spreadsheet templates have been provided throughout the book to help visualize many of the discussions on data. Features and Benefits Supply / Demand Fundamentals Market overviews (financial and physical) Contracts Derivatives Technical Analysis Risk Controls Audience Field level personnel Management Energy lending and finance professionals Anyone who seeks to understand how, or relies upon, energy markets Students</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fletcher J. Sturm
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      PennWell
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6038081a